<template>
  <div>
    <div class="ui warning message" v-if="!isRoomShiftInProgress">
      <div class="header">
        You must start the shift for this room
      </div>
      Start shift for current room and try again
    </div>

    <table class="ui very basic very compact table">
      <tbody>
        <tr 
          v-for="(visit, index) in test" 
          :key="visit.timeSlot"
            :class="{
              pending: [VisitStatuses.PENDING, VisitStatuses.UN_REACHED].includes(visit.visit_status_id),
              positive: [VisitStatuses.IN_VISIT].includes(visit.visit_status_id),
              negative: [VisitStatuses.CANCELLED].includes(visit.visit_status_id),
              waiting: [VisitStatuses.WAITING].includes(visit.visit_status_id),
              'after-work': [VisitStatuses.AFTER_WORK, VisitStatuses.FINISHED].includes(visit.visit_status_id),
              confirmed: [VisitStatuses.CONFIRMED].includes(visit.visit_status_id),
            }"
        >
          <td 
            width="8%" 
            style="border-top: 1px; padding-left: 5px;"
          >
            {{ visit.timeSlot}}
          </td>
          <td :rowspan="visit.time_slots || 1" v-if="visit.id">
            <div 
              class="ui card" 
              style="width: 95%"
              :class="{
                'pending-border': [VisitStatuses.PENDING, VisitStatuses.UN_REACHED].includes(visit.visit_status_id),
                'positive-border': [VisitStatuses.IN_VISIT].includes(visit.visit_status_id),
                'negative-border': [VisitStatuses.CANCELLED].includes(visit.visit_status_id),
                'waiting-border': [VisitStatuses.WAITING].includes(visit.visit_status_id),
                'after-work-border': [VisitStatuses.AFTER_WORK, VisitStatuses.FINISHED].includes(visit.visit_status_id),
                'confirmed-border': [VisitStatuses.CONFIRMED].includes(visit.visit_status_id),
              }"
            >
              <div class="content">
                <div 
                  class="header" 
                  @click="goToPatient(patientsByReservationId[visit.reservation_id])"
                  style="cursor: pointer"
                >
                  <a>
                  {{ adjustName(patientsByReservationId[visit.reservation_id].name) }}
                  </a>
                  <p 
                    style="float: right; font-size: 20px; font-weight: bold;"
                    :class="{
                      'pending': [VisitStatuses.PENDING, VisitStatuses.UN_REACHED].includes(visit.visit_status_id),
                      'positive': [VisitStatuses.IN_VISIT].includes(visit.visit_status_id),
                      'negative': [VisitStatuses.CANCELLED].includes(visit.visit_status_id),
                      'waiting': [VisitStatuses.WAITING].includes(visit.visit_status_id),
                      'after-work': [VisitStatuses.AFTER_WORK, VisitStatuses.FINISHED].includes(visit.visit_status_id),
                      'confirmed': [VisitStatuses.CONFIRMED].includes(visit.visit_status_id),
                    }"
                  > 
                    {{ VisitStatuses[visit.visit_status_id] }}
                  </p>
                  <div style="clear: both"></div>
                </div>
                <div class="description">
                  <div v-html="packagesString(visit)" />
                  <strong>Mobile</strong>{{ ' ' + patientsByReservationId[visit.reservation_id].cell_phone }} <br/>
                 <span style="border:1px solid black; font-weight:bold" v-if="visit.note"> {{ visit.note }} </span>
                </div>
              </div>
              <div class="extra content">
                <div 
                  class="ui mini buttons"
                  :class="getNumberOfButtons(visit)"
                >
                  <div 
                    class="ui basic green button"
                    @click="goToReservationVisit(visit.reservationVisit.id)"
                  >
                    Show visit
                  </div>
                  <div 
                    class="ui basic red button"
                    @click="goToReservation(visit.reservation_id)"
                  >
                    Show reservation
                  </div>
                  <div 
                    class="ui basic blue button"
                    @click="showModal(visit.reservationVisit.id, visit.visit_status_id)"
                    v-if="getNumberOfButtons(visit) === 'three'"
                  >
                    Actions
                  </div>
                </div>
              </div>
            </div>
          </td>
          <td v-if="!visit.isReserved && ($auth.check('employee') || isAdmin())">
            <div class="ui fluid very compact mini buttons">
              <div 
                class="ui gray button"
                style="background-color: #e9f0fa"
                v-if="(!startIndex && startIndex != 0) || index == startIndex"
                @click="setStartIndex(index)"
              > 
                Set start time
              </div>
              <div 
                class="ui teal button"
                v-if="canHasEndButton(index)"
                @click="setEndIndex(index)"
                :id="'endTime' + index"
              >
                set end time
              </div>
              <div class="ui flowing popup top left transition hidden" :id="'visit-popup' + index">
                <patientSearch 
                  v-if="index === endIndex && currentPopup === popups.first"
                  @room-patient-search="roomPatientSearchEventListenner"
                />
                <reservationSearch 
                  v-if="index === endIndex && currentPopup === popups.second"
                  :patient="patient"
                  @room-reservation-search="roomReservationSearchEventListenner"
                />
                <visitDetail 
                  v-if="index === endIndex && currentPopup === popups.third"
                  @visit-note="visitDetailEventListenner"
                />
              </div>
            </div>
          </td>
          <td v-if="!visit.isReserved && $auth.check('doctor') && !isAdmin()"></td>
        </tr>
      </tbody>
    </table>
    <div class="ui large longer modal" :id="'visitStatus'" style="margin-top: 20px !important;">
      <div class="header">Set inital visit status</div>

      <div class="content">
          <!-- style="background-color: #092442" -->
        <button 
          class="ui pending button" 
          @click="setVisitPending()"
          v-if="[VisitStatuses.CONFIRMED, VisitStatuses.UN_REACHED, VisitStatuses.WAITING].includes(choosenReservationVisitStatusId)"
        >
          Pending
        </button>

        <button 
          class="ui teal button" 
          style="background-color: #092442"
          @click="setVisitConfirmed()"
          v-if="[VisitStatuses.PENDING, VisitStatuses.UN_REACHED].includes(choosenReservationVisitStatusId)"
        >
          Confirmed
        </button>
        
        <button 
          class="ui teal button" 
          style="background-color: #092442"
          @click="setVisitUnReached()"
          v-if="[VisitStatuses.PENDING, VisitStatuses.UN_REACHED].includes(choosenReservationVisitStatusId)"
        >
          Un-Reached
        </button>

        <button 
          class="ui teal button" 
          style="background-color: #092442"
          @click="setVisitWaiting()"
          v-if="[VisitStatuses.PENDING, VisitStatuses.CONFIRMED, VisitStatuses.UN_REACHED].includes(choosenReservationVisitStatusId)"
        >
          Waiting
        </button>

        <button 
          class="ui teal button" 
          style="background-color: #092442"
          @click="startVisit()"
          v-if="[VisitStatuses.WAITING].includes(choosenReservationVisitStatusId)"
        >
          Start visit
        </button>

        <button 
          class="ui teal button" 
          style="background-color: #092442"
          @click="setVisitAfterWork()"
          v-if="[VisitStatuses.IN_VISIT].includes(choosenReservationVisitStatusId)"
        >
          After work
        </button>

        <button 
          class="ui teal button" 
          style="background-color: #092442"
          @click="finalizeVisit()"
          v-if="[VisitStatuses.IN_VISIT, VisitStatuses.AFTER_WORK].includes(choosenReservationVisitStatusId)"
        >
          Finish
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    patientSearch: require('./visits_popup_components/PatientSearch').default,
    reservationSearch: require('./visits_popup_components/ReservationSearch').default,
    visitDetail: require('./visits_popup_components/VisitDetail').default,
  },
  props: {
    roomId: { type: Number, required: true},
    visits: { type: Array, default: () => {} },
    packages: { type: Array, required: true},
    reservations: { type: Array, required: true},
    patients: { type: Array, required: true},
    reservationVisits: { type: Array, required: true},
    doctorName: { type: String, required: false},
    isRoomShiftInProgress: { type: Boolean, default: false },
    currentDate: { type: Object, default: window.moment() },
    transactions: { type: Array, default: () => [] }
  },
  data() {
    return {
      componentVisits: [],
      packagesById: {},
      patientsByReservationId: {},
      choosenReservationVisitId: null,
      choosenReservationVisitStatusId: null,
      test: [],
      startIndex: null,
      endIndex: null,
      patient: null,
      reservationId: null,
      popups: {
        first: 'patientSearch',
        second: 'reservationSearch',
        third: 'visitDetail'
      },
      currentPopup: 'patientSearch',
      sendData: {}
    }
  },
  mounted () {
    this.formatVisits()
    this.$nextTick(() => {
      $('#visit-popup').popup({
        on: 'click',
        position: 'bottom center'
      })
    })
  },
  computed: {
    dayHours() {
      const startTime = window.moment().set({hour: 7, minute: 0});
      // startTime.setHours(7, 0, 0, 0)
      
      const endTime = window.moment().set({hour: 23, minute: 59});
      // endTime.setHours(23, 59, 0, 0)

      const times = [window.moment(startTime).format("hh:mm A")];
      while (endTime > startTime) {
        const currentMinutes = Number(startTime.minutes()) + 15
        const currentHour = Number(startTime.hour())

        startTime.set({hour: currentHour, minute: currentMinutes})
        times.push(startTime.format("hh:mm A"))
      }

      return times
    }
  },
  methods: {
    formatVisits() {
      const reservationVisitsByVisitId = 
        this.reservationVisits.reduce((obj, rv) => ({...obj, [rv.visit_id]: rv}), {})
      
      this.packagesById = this.packages.reduce((obj, p) => ({ ...obj, [p.id]: p }), {})

      const patientsById = 
        this.patients.reduce((obj, patient) => ({...obj, [patient.id]: patient}), {});

      this.patientsByReservationId = this.reservations.reduce((obj, reservation) => ({ 
        ...obj, 
        [reservation.id]: patientsById[reservation.patient_id] 
      }), {});

      this.componentVisits = this.visits.map(visit => ({
        ...visit,
        reservationVisit: reservationVisitsByVisitId[visit.id],
      })).filter(visit => ![this.VisitStatuses.CANCELLED].includes(visit.visit_status_id))
      
      const newComponentVisits = this.componentVisits.reduce((obj, visit) => {
        return {
          ...obj,
          [window.moment(visit.time).format("hh:mm A")]: visit
        }
      }, {})

      let reserved = 0
      let visitStatus = null
      this.test = this.dayHours.map(timeSlot => {
        let visit = newComponentVisits[timeSlot]
        if (this.$auth.check('doctor') && !this.isAdmin()) {
          visit = visit && this.getVisitStatusesAllowedForTheDoctor().includes(visit.visit_status_id) ?
            visit : null
        }
        reserved = visit && visit.time_slots ? visit.time_slots : reserved
        visitStatus = visit && visit.visit_status_id ? visit.visit_status_id : visitStatus
        const currentReserved = reserved
        visitStatus = reserved > 0 ? visitStatus : null
        reserved = reserved > 0 ? reserved - 1 : 0
        return {
          timeSlot,
          ...visit,
          isReserved: currentReserved > 0,
          visit_status_id: visitStatus
        }
      })
    }, 
    packagesString (visit) {
      const visitPackageIds = visit.visit_details.map(vd => vd.package_id)
      const reservation = this.reservations.find(reservation => reservation.id === visit.reservation_id)
      let packages = ''
      reservation.reservations_packages.forEach(rp => {
        if (visitPackageIds.includes(rp.package_id)) {
          const p = this.packagesById[rp.package_id]
          const unitMeasurement = this.unitMeasurements.find(p.unit_measurement_id).name
          const packageTotalPrice = Number(rp.repeated) * Number(p.unit_price) * Number(p.quantity)
          
          const reservationPackageTransactionIds = 
            reservation.reservation_transactions.filter(rt => rt.package_id === p.id)
              .map(rt => rt.transaction_id)
          
          const packageTransactions = this.transactions.map(t => reservationPackageTransactionIds.includes(t.id) && t).filter(Boolean)
          const totalPaid = window._.sumBy(packageTransactions, pt => Number(pt.amount))
          const remainderPrice = packageTotalPrice - totalPaid
          
          packages += `<strong>${p.name}</strong>: <span style="color: ${Number(rp.remainder) > 0 ? 'green' : 'red'}"> ${Number(rp.remainder)}</span> ${unitMeasurement} - <span style="color:${remainderPrice > 0 ? 'red' : 'green'}">${this.formatPrice(remainderPrice)}</span>, `
        }
      })

      return packages.trim().slice(0, -1)
    },
    reformatData() {
      const newComponentVisits = this.componentVisits.reduce((obj, visit) => {
        return {
          ...obj,
          [window.moment(visit.time).format("hh:mm A")]: visit
        }
      }, {})

      let reserved = 0
      let visitStatus = null
      this.test = this.dayHours.map(timeSlot => {
        const visit = newComponentVisits[timeSlot]
        reserved = visit && visit.time_slots ? visit.time_slots : reserved
        visitStatus = visit && visit.visit_status_id ? visit.visit_status_id : visitStatus
        const currentReserved = reserved
        visitStatus = reserved > 0 ? visitStatus : null
        reserved = reserved > 0 ? reserved - 1 : 0
        return {
          timeSlot,
          ...visit,
          isReserved: currentReserved > 0,
          visit_status_id: visitStatus
        }
      })
    },
    goToReservation(reservationId) {
      this.navigateTo(`Show_Reservation`, {
        key: 'params',
        value: { id: reservationId }
      })
    },
    goToReservationVisit(reservationVisitId) {
      this.navigateTo(`Show_Visit`, {
        key: 'params',
        value: { reservationVisitId: reservationVisitId }
      })
    },
    timeFormat (time) {
      return window.moment(time).format('LLLL')
    },
    getDoctorName (doctorId) {
      return this.doctorsMeta.find(doctorId).user.name
    },
    showModal (reservationVisitId, visitStatusId) {
      this.choosenReservationVisitId = reservationVisitId
      this.choosenReservationVisitStatusId = visitStatusId
      $('#visitStatus').modal('show')
    },
    hideModal () {
      $('#visitStatus').modal('hide')
    },
    setVisitConfirmed () {
      this.$http.put(`reservation_visits/${this.choosenReservationVisitId}/set/visit/confirmed`)
        .then(response => {
          let visit = this.componentVisits.find(visit => visit.id === response.data.id)
          visit.visit_status_id = response.data.visit_status_id
          this.reformatData()
          this.hideModal()
        })
    },
    setVisitUnReached () {
      this.$http.put(`reservation_visits/${this.choosenReservationVisitId}/set/visit/unreached`)
        .then(response => {
          let visit = this.componentVisits.find(visit => visit.id === response.data.id)
          visit.visit_status_id = response.data.visit_status_id
          this.reformatData()
          this.hideModal()
        })
    },
    setVisitPending () {
      this.$http.put(`reservation_visits/${this.choosenReservationVisitId}/set/visit/pending`)
        .then(response => {
          let visit = this.componentVisits.find(visit => visit.id === response.data.id)
          visit.visit_status_id = response.data.visit_status_id
          this.reformatData()
          this.hideModal()
        })
    },
    setVisitAfterWork () {
      this.$http.put(`reservation_visits/${this.choosenReservationVisitId}/set/visit/after-work`)
        .then(response => {
          let visit = this.componentVisits.find(visit => visit.id === response.data.id)
          visit.visit_status_id = response.data.visit_status_id
          this.reformatData()
          this.hideModal()
        })
    },
    setVisitWaiting () {
      this.$http.put(`reservation_visits/${this.choosenReservationVisitId}/set/visit/waiting`)
        .then(response => {
          let visit = this.componentVisits.find(visit => visit.id === response.data.id)
          visit.visit_status_id = response.data.visit_status_id
          visit.number = response.data.number
          this.reformatData()
          this.hideModal()
        })
    },
    cancel () {
      this.$http.post(`reservation_visits/${this.choosenReservationVisitId}/cancel`)
        .then(response => {
          let visit = this.componentVisits.find(visit => visit.id === response.data.id)
          visit.visit_status_id = response.data.visit_status_id
          visit.number = response.data.number
          this.reformatData()
          this.hideModal()
        })
    },
    startVisit () {
      this.$http
          .post(`reservation_visits/${this.choosenReservationVisitId}/start`, {
            clinic_id: this.getClinicId()
          })
          .then(response => {
            let visit = this.componentVisits.find(visit => visit.id === response.data.id)
            visit.visit_status_id = response.data.visit_status_id
            visit.started_at = response.data.started_at;
            this.reformatData()
            this.hideModal()
          });
    },
    finalizeVisit () {
      this.hideModal()
      this.navigateTo('Finalize_visit', {
          key: 'params',
          value: {
            reservationVisitId: this.choosenReservationVisitId
          }
        })
    },
    getEndTime(visit) {
      const startTime = window.moment(visit.time).add(((visit.time_slots) * 15), 'minutes')
      // const calculatedMinutes = startTime.getMinutes() + ((visit.time_slots) * 15)

      // startTime.setHours(startTime.getHours(), calculatedMinutes, 0, 0)
      return startTime.format("hh:mm A")
    },
    canHasEndButton(index) {
      if (!this.startIndex && this.startIndex != 0) return false;
      if(index < this.startIndex) return false;
      for (let i = this.startIndex; i < index; ++i) {
        if (this.test[i].id) return false
      }

      return true
    },
    setStartIndex(index) {
      this.patient = null
      this.reservationId = null
      this.currentPopup = this.popups.first
      if (this.startIndex || this.startIndex === 0) {
        this.startIndex = null;
        this.endIndex = null;
      } else {
        this.startIndex = index
      }
    },
    setEndIndex(index) {
      this.patient = null
      this.reservationId = null
      this.currentPopup = this.popups.first
      this.endIndex = index
      this.$nextTick(() => {
        $('#endTime' + index).popup({
          inline     : true,
          position   : 'bottom center',
          on: 'click',
          onHide: () => {
            this.patient = null
            this.reservationId = null
            this.currentPopup = this.popups.first
          }
        }).popup('show')
      })
    },
    roomPatientSearchEventListenner(event) {
      this.patient = event.data.patient
      this.currentPopup = this.popups.second 
    },
    roomReservationSearchEventListenner(event) {
      const startTime = this.test[this.startIndex].timeSlot.split(":")
      let choosenHour = Number(startTime[0])
      const choosenMinutes = startTime[1].split(" ")[0]

      if (startTime[1].split(" ")[1].trim() === "PM" && choosenHour != 12) {
        choosenHour += 12
      }

      if (choosenHour === 12 && startTime[1].split(" ")[1].trim() === "AM") {
        choosenHour = 0
      }

      const visitTime = this.currentDate
      visitTime.set({hour: choosenHour, minute: choosenMinutes})
      
      this.sendData = {
        clinic_id: this.getClinicId(),
        reservation_id: event.data.reservation.id,
        room_id: this.roomId,
        time_slots: this.endIndex - this.startIndex + 1,
        time: visitTime
      }
      this.currentPopup = this.popups.third
    },
    visitDetailEventListenner(event) {
      this.sendData.note = event.data.note
      
      this.$http.post('reservation_visits', {
          visit: this.sendData
      }).then(response => {
        this.navigateTo('Show_Visit', {
          key: 'params',
          value: { 
            reservationVisitId: response.data.id 
          }
        })
      })
    },
    goToPatient(patient) {
      this.navigateTo('Show_Patient', {
        key: 'params',
        value: { id: patient.id }
      })
    },
    getNumberOfButtons(visit) {
      if (this.$auth.check('doctor') && !this.isAdmin()) {
        return this.VisitStatuses.DOCTOR_ALLOWABLE_STATUSES.includes(visit.visit_status_id) ?
         'three' : 'two'
      } 

      return 'three'
    }
  },
  beforeDestroy () {
    $('#visitStatus').remove()
  }, 
}
</script>

<style scoped>
  .id-link {
    cursor: pointer; 
    text-decoration:underline;
  }
  .waiting {
    background-color: rgba(255,165,0, 0.1);
    color:darkorange;
  }
  .after-work {
    background-color: rgba(238,130,238,0.2);
    color: darkviolet;
  }
  .pending {
    background-color: #fff9c4 !important;
    color: black;
  }
  .confirmed {
    background-color: #54c5e9;
    color: darkblue;
  }
  .reserved {
    background-color: #ededed;
    color: black;
  }
  .waiting-border {
    border-left: 10px solid darkorange;
  }
  .after-work-border {
    border-left: 10px solid darkviolet;
  }
  .reserved-border {
    border-left: 10px solid black;
  }
  .positive-border {
    border-left: 10px solid #2c662d;
  }
  .negative-border {
    border-left: 10px solid red;
  }
  .confirmed-border {
    border-left: 10px solid blue;
  }
  .pending-border {
    border-left: 10px solid yellow;
  }
</style>



// WEBPACK FOOTER //
// src/components/rooms/room_components/Visits.vue